module.exports = __webpack_public_path__ + "img/logo-light.cbccb9e7.svg";